/** Контакты поддержки — единое место. Сайт-виджет остаётся основным каналом, бот и почта — дополнительные. */
export const SUPPORT_EMAIL = 'support@chatx.click'
export const SUPPORT_BOT_URL = 'https://t.me/ChatX_Support_bot'
export const SUPPORT_BOT_HANDLE = '@ChatX_Support_bot'
/** Канал новостей продукта в Telegram — единое место для всех ссылок. */
export const TELEGRAM_NEWS_URL = 'https://t.me/chatx_updates'

const BOT_LABEL_KEY = 'help.contacts.telegram_bot'

/** Подпись ссылки на бота: ключ словаря, пока его нет на бэке — встроенный текст по языку. */
export function supportBotLabel(t: (key: string) => string, language: string): string {
  const value = t(BOT_LABEL_KEY)
  if (value && value !== BOT_LABEL_KEY) return value
  return language === 'ru' ? 'Бот поддержки в Telegram' : 'Support bot in Telegram'
}
